import { render, staticRenderFns } from "./PresentLevelsResults.vue?vue&type=template&id=646b2075&scoped=true"
import script from "./PresentLevelsResults.vue?vue&type=script&lang=js"
export * from "./PresentLevelsResults.vue?vue&type=script&lang=js"
import style0 from "./PresentLevelsResults.vue?vue&type=style&index=0&id=646b2075&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646b2075",
  null
  
)

export default component.exports